export default __webpack_public_path__ + "static/media/ic_tokens.6a27251b.svg";